<template>
    <div class="col-grid-2">
        <div class="lcu-profile-col1">
            <div class="lcu-form-fieldWrap">
                <label class="lcu-section-label" for="first-name">
                    <!-- TODO: this will need to be editable -->
                    Correo Electrónico
                </label>
                <span>{{ validations.email.value }}</span>
            </div>
            <!-- first name -->
            <div class="lcu-form-fieldWrap">
                <label class="lcu-section-label" for="first-name">
                    Nombre
                    <button
                        type="button"
                        aria-label="edit first name"
                        @click.prevent="toggleEdit('firstName')"
                        :class="{
                            'lcu-cancel-btn': edit.firstName
                        }"
                        class="lcu-edit-btn" />
                </label>
                <span v-if="!edit.firstName">{{ validations.firstName.value }}</span>
                <div class="row row-small"  v-if="edit.firstName">
                    <div class="lcu-input-grid">
                        <form-field :id="'first-name'" :label="''">
                            <input
                                type="text"
                                name="first-name"
                                id="first-name"
                                @input="validate(['firstName'])"
                                v-model="validations.firstName.value"
                                :class="{
                                    'lcu-form-inputError': validations.firstName.errors.length > 0
                                }"
                                autocomplete="on"
                                class="lcu-form-inputText" />
                        </form-field>
                        <button-cta
                            :text="SAVE_TEXT"
                            :loading="loaders.firstName"
                            @on-click="onSave('firstName')" />
                    </div>
                    <span
                        class="lcu-form-error"
                        v-if="validations.firstName.errors.length > 0">
                        {{ validations.firstName.errors.join(' ') }}
                    </span>
                </div>
            </div>
            <!-- last name -->
            <div class="lcu-form-fieldWrap">
                <label class="lcu-section-label" for="last-name">
                    Apellido
                    <button
                        type="button"
                        aria-label="edit last name"
                        @click.prevent="toggleEdit('lastName')"
                        :class="{
                            'lcu-cancel-btn': edit.lastName
                        }"
                        class="lcu-edit-btn" />
                </label>
                <span v-if="!edit.lastName">{{ validations.lastName.value }}</span>
                <div class="row row-small"  v-if="edit.lastName">
                    <div class="lcu-input-grid">
                        <form-field :id="'last-name'" :label="''">
                            <input
                                type="text"
                                name="last-name"
                                id="last-name"
                                @input="validate(['lastName'])"
                                v-model="validations.lastName.value"
                                :class="{
                                    'lcu-form-inputError': validations.lastName.errors.length > 0
                                }"
                                autocomplete="on"
                                class="lcu-form-inputText" />
                        </form-field>
                        <button-cta
                            :text="SAVE_TEXT"
                            :loading="loaders.lastName"
                            @on-click="onSave('lastName')" />
                    </div>
                    <span
                        class="lcu-form-error"
                        v-if="validations.lastName.errors.length > 0">
                        {{ validations.lastName.errors.join(' ') }}
                    </span>
                </div>
            </div>
            <!-- address -->
            <div class="lcu-form-fieldWrap">
                <label class="lcu-section-label">
                    Dirección
                    <button
                        type="button"
                        aria-label="edit name"
                        @click.prevent="toggleEdit('address')"
                        :class="{
                            'lcu-cancel-btn': edit.address
                        }"
                        class="lcu-edit-btn" />
                </label>
                <span v-if="!edit.address">{{ _getFullAddress(user) }}</span>
                <div v-if="edit.address">
                    <div class="col-grid-2">
                        <div>
                            <div class="lcu-form-subField">
                                <form-field :id="'street'" :label="'Street Address'">
                                    <input
                                        type="text"
                                        name="street"
                                        id="street"
                                        @input="''"
                                        v-model="validations.address.value.street"
                                        :class="{
                                            'lcu-form-inputError': false
                                        }"
                                        autocomplete="on"
                                        class="lcu-form-inputText" />
                                </form-field>
                            </div>
                            <div class="lcu-form-subField">
                                <form-field :id="'city'" :label="'City'">
                                    <input
                                        type="text"
                                        name="city"
                                        id="city"
                                        @input="''"
                                        v-model="validations.address.value.city"
                                        :class="{
                                            'lcu-form-inputError': false
                                        }"
                                        autocomplete="on"
                                        class="lcu-form-inputText" />
                                </form-field>
                            </div>
                            <div class="lcu-form-subField">
                                <form-field :id="'country'" :label="'Country'" :select="true">
                                    <select
                                        id="country"
                                        name="country"
                                        v-model="validations.address.value.country"
                                        @change.prevent="setCountryStates"
                                        class="lcu-form-select">
                                        <option :value="c" v-for="c in allCountries" :key="c">
                                            {{ c }} {{ countryData[c].flag }}
                                        </option>
                                    </select>
                                </form-field>
                            </div>
                        </div>
                        <div>
                            <div class="lcu-form-subField">
                                <form-field :id="'apt'" :label="'Apartment, Suite, etc'">
                                    <input
                                        type="text"
                                        name="apt"
                                        id="apt"
                                        @input="''"
                                        v-model="validations.address.value.apt"
                                        :class="{
                                            'lcu-form-inputError': false
                                        }"
                                        autocomplete="on"
                                        class="lcu-form-inputText" />
                                </form-field>
                            </div>
                            <div class="lcu-form-subField">
                                <form-field :id="'state'" :label="'State'" :select="true">
                                    <select
                                        id="state"
                                        name="state"
                                        v-model="validations.address.value.state"
                                        @change.prevent="''"
                                        class="lcu-form-select">
                                        <option
                                            :value="state"
                                            v-for="state in allStates"
                                            :key="state">
                                            {{ state }}
                                        </option>
                                    </select>
                                </form-field>
                            </div>
                            <div class="lcu-form-subField">
                                <form-field :id="'zip-code'" :label="'Zip Code'">
                                    <input
                                        type="text"
                                        name="zip-code"
                                        id="zip-code"
                                        @input="''"
                                        v-model="validations.address.value.zip"
                                        :class="{
                                            'lcu-form-inputError': false
                                        }"
                                        autocomplete="on"
                                        class="lcu-form-inputText" />
                                </form-field>
                            </div>
                        </div>
                    </div>
                    <div class="lcu-address-buttons">
                        <button-cta
                            :text="SAVE_TEXT"
                            :loading="loaders.address"
                            @on-click="onSave('address')" />
                    </div>
                </div>
            </div>
            <!-- phone -->
            <div class="lcu-form-fieldWrap">
                <label class="lcu-section-label" for="phone">
                    Teléfono
                    <button
                        type="button"
                        aria-label="edit phone"
                        @click.prevent="toggleEdit('phone')"
                        :class="{
                            'lcu-cancel-btn': edit.phone
                        }"
                        class="lcu-edit-btn" />
                </label>
                <span v-if="!edit.phone">{{ validations.phone.value || 'N/A' }}</span>
                <div class="row row-small"  v-if="edit.phone">
                    <div class="lcu-input-grid">
                        <form-field :id="'phone'" :label="''">
                            <input
                                type="tel"
                                name="phone"
                                id="phone"
                                @input="validate(['phone'])"
                                v-model="validations.phone.value"
                                :class="{
                                    'lcu-form-inputError': validations.phone.errors.length > 0
                                }"
                                autocomplete="on"
                                class="lcu-form-inputText" />
                        </form-field>
                        <button-cta
                            :text="SAVE_TEXT"
                            :loading="loaders.phone"
                            @on-click="onSave('phone')" />
                    </div>
                    <span
                        class="lcu-form-error"
                        v-if="validations.phone.errors.length > 0">
                        {{ validations.phone.errors.join(' ') }}
                    </span>
                </div>
            </div>
            <!-- birth date -->
            <div class="lcu-form-fieldWrap">
                <label class="lcu-section-label" for="last-name">
                    Fecha de Nacimiento
                    <button
                        type="button"
                        aria-label="edit birth date"
                        @click.prevent="toggleEdit('birthday')"
                        :class="{
                            'lcu-cancel-btn': edit.birthday
                        }"
                        class="lcu-edit-btn" />
                </label>
                <span v-if="!edit.birthday">{{ validations.birthday.value }}</span>
                <div class="row row-small"  v-if="edit.birthday">
                    <div class="lcu-input-grid">
                        <form-field :id="'birthday'" :label="''">
                            <input
                                type="text"
                                name="birthday"
                                id="birthday"
                                @input="validate(['birthday'])"
                                v-maska="'## / ## / ####'"
                                placeholder="MM / DD / YYYY"
                                v-model="validations.birthday.value"
                                :class="{
                                    'lcu-form-inputError': validations.birthday.errors.length > 0
                                }"
                                autocomplete="on"
                                class="lcu-form-inputText" />
                        </form-field>
                        <button-cta
                            :text="SAVE_TEXT"
                            :loading="loaders.birthday"
                            @on-click="onSave('birthday')" />
                    </div>
                    <span
                        class="lcu-form-error"
                        v-if="validations.birthday.errors.length > 0">
                        {{ validations.birthday.errors.join(' ') }}
                    </span>
                </div>
            </div>
            <!-- gender -->
            <div class="lcu-form-fieldWrap">
                <label class="lcu-section-label" for="gender">
                    Género
                    <button
                        type="button"
                        aria-label="edit gender"
                        @click.prevent="toggleEdit('gender')"
                        :class="{
                            'lcu-cancel-btn': edit.gender
                        }"
                        class="lcu-edit-btn" />
                </label>
                <span v-if="!edit.gender">{{ _startCase(validations.gender.value) }}</span>
                <div class="lcu-input-grid" v-if="edit.gender">
                    <form-field :id="'country'" :label="''" :select="true">
                        <select
                            id="gender"
                            name="gender"
                            v-model="validations.gender.value"
                            class="lcu-form-select">
                            <option :value="g" v-for="g in ['male', 'female']" :key="g">
                                {{ _startCase(g) }}
                            </option>
                        </select>
                    </form-field>
                    <button-cta
                        :text="SAVE_TEXT"
                        :loading="loaders.gender"
                        @on-click="onSave('gender')" />
                </div>
            </div>
            <!-- password -->
            <div class="lcu-form-fieldWrap">
                <label class="lcu-section-label" for="password">
                    Contraseña
                    <button
                        type="button"
                        aria-label="edit first name"
                        @click.prevent="toggleEdit('password')"
                        :class="{
                            'lcu-cancel-btn': edit.password
                        }"
                        class="lcu-edit-btn" />
                </label>
                <span v-if="!edit.password">************</span>
                <div v-if="edit.password">
                    <div class="row row-small">
                        <form-field
                            :id="'old-password'"
                            :label="'Contraseña actual'"
                            :required="true">
                            <tooltip
                                :text="(showOldPass ? 'Ocultar' : 'Mostrar') + ' contraseña'"
                                :tag="'button'"
                                name="show-old-password"
                                :on-click="() => { showOldPass = !showOldPass; }"
                                :classes="['lcu-icon-eyeSlash', {
                                    'lcu-icon-eye': showOldPass
                                }]" />
                            <input
                                :type="showOldPass ? 'text' : 'password'"
                                name="old-password"
                                id="old-password"
                                v-model="validations.oldPassword.value"
                                @input="validate(['oldPassword'])"
                                :class="{
                                    'lcu-form-inputError': validations.oldPassword.errors.length > 0
                                }"
                                class="lcu-form-inputText" />
                            <span
                                class="lcu-form-error"
                                v-if="validations.oldPassword.errors.length > 0">
                                {{ validations.oldPassword.errors.join(' ') }}
                            </span>
                        </form-field>
                    </div>
                    <div class="row row-small">
                        <form-field
                            :id="'new-password'"
                            :label="'Nueva contraseña'"
                            :required="true">
                            <tooltip
                                :text="(showNewPass ? 'Ocultar' : 'Mostrar') + ' contraseña'"
                                :tag="'button'"
                                name="show-new-password"
                                :on-click="() => { showNewPass = !showNewPass; }"
                                :classes="['lcu-icon-eyeSlash', {
                                    'lcu-icon-eye': showNewPass
                                }]" />
                            <input
                                :type="showNewPass ? 'text' : 'password'"
                                name="new-password"
                                id="new-password"
                                v-model="validations.newPassword.value"
                                @input="validate(['newPassword']); checkConfirm(); showHint();"
                                :class="{
                                    'lcu-form-inputError': newPassError || showCriteriaError,
                                }"
                                class="lcu-form-inputText" />
                            <span
                                class="lcu-form-error" v-if="newPassError || showCriteriaError">
                                {{ validations.newPassword.errors.join(' ') }}
                                <span v-if="confirmError"> {{ confirmError }} </span>
                                <span v-if="showCriteriaError">
                                    {{ formValidationMessages.passwordCriteria }}
                                </span>
                            </span>
                        </form-field>
                    </div>
                    <div class="row row-small" v-if="showHintGroup">
                        <div class="lcu-passHint-group">
                            <span
                            class="lcu-hintPass"
                            :class="{ 'lcu-hintPass-good': hint.lc }">
                            {{ passwordHintMessages.lc }}
                            </span><br/>
                            <span
                            class="lcu-hintPass"
                            :class="{ 'lcu-hintPass-good': hint.uc }">
                            {{ passwordHintMessages.uc }}
                            </span><br/>
                            <span
                            class="lcu-hintPass"
                            :class="{ 'lcu-hintPass-good': hint.num }">
                            {{ passwordHintMessages.num }}
                            </span><br/>
                            <span
                            class="lcu-hintPass"
                            :class="{ 'lcu-hintPass-good': hint.sym }">
                            {{ passwordHintMessages.sym }}
                            </span><br/>
                            <span
                            class="lcu-hintPass"
                            :class="{ 'lcu-hintPass-good': hint.len }">
                            {{ passwordHintMessages.len }}
                            </span><br/>
                        </div>
                    </div>
                    <div class="row row-small">
                        <form-field
                            :id="'confirm-password'"
                            :label="'Confirmar contraseña'"
                            :required="true">
                            <tooltip
                                :text="(showConfirmPass ? 'Ocultar' : 'Mostrar') + ' contraseña'"
                                :tag="'button'"
                                name="show-confirm-password"
                                :on-click="() => { showConfirmPass = !showConfirmPass; }"
                                :classes="['lcu-icon-eyeSlash', {
                                    'lcu-icon-eye': showConfirmPass
                                }]" />
                            <input
                                :type="showConfirmPass ? 'text' : 'password'"
                                name="confirm-password"
                                id="confirm-password"
                                v-model="validations.confirmNewPassword.value"
                                @input="validate(['confirmNewPassword']); checkConfirm();"
                                :class="{
                                    'lcu-form-inputError': confirmPassError
                                }"
                                class="lcu-form-inputText" />
                            <span class="lcu-form-error" v-if="confirmPassError">
                            {{ validations.confirmNewPassword.errors.join(' ') }}
                            <span v-if="confirmError"> {{ confirmError }}</span>
                            </span>
                        </form-field>
                    </div>
                    <div class="lcu-address-buttons">
                        <button-cta
                            :text="SAVE_TEXT"
                            :loading="loaders.password"
                            @on-click="onPasswordSave" />
                    </div>
                </div>
            </div>
        </div>
        <!-- profile pic -->
        <div class="lcu-profile-col2">
            <div class="lcu-image-wrapper">
                <img
                    class="lcu-profile-image"
                    :src="user.profilePic || '/assets/default-profile.svg'"
                    alt="profile picture" />
                <button
                    type="button"
                    class="lcu-edit-imageBtn"
                    @click.prevent="openImage = true"/>
            </div>
        </div>
    </div>
    <ProfileImageModal
        :is-open="openImage"
        @set-modal="setImageModal" />
</template>

<script>
import { mapGetters } from 'vuex';
import { Country, State } from 'country-state-city';
import ButtonCta from 'ç/buttons/Cta.vue';
import FormField from 'ç/forms/inputs/Field.vue';
import Tooltip from 'ç/tooltip/Tooltip.vue';
import { SAVE_TEXT, NOTIFICATION_SUCCESS, NOTIFICATION_ERROR } from '@/globals/constants';
import validations from '@/mixins/Validator.vue';
import passwordCriteria from '@/mixins/PasswordCriteria.vue';
import ProfileImageModal from './ProfileImageModal.vue';

export default {
  name: 'profile-page',
  computed: {
    ...mapGetters(['user']),
    newPassError() {
      return this.validations.newPassword.errors.length > 0 || this.confirmError;
    },
    confirmPassError() {
      return this.validations.confirmNewPassword.errors.length > 0 || this.confirmError;
    },
    showCriteriaError() {
      const input = this.validations.newPassword.value.replace(/\s+/g, '');
      return !this.criteriaPass && input !== '';
    },
  },
  mixins: [validations, passwordCriteria],
  components: {
    ButtonCta,
    ProfileImageModal,
    Tooltip,
    'form-field': FormField,
  },
  data() {
    return {
      openImage: false,
      showOldPass: false,
      showNewPass: false,
      showConfirmPass: false,
      allCountries: [],
      allStates: [],
      SAVE_TEXT,
      validations: {
        firstName: {
          value: '',
          required: true,
          errors: [],
        },
        lastName: {
          value: '',
          required: true,
          errors: [],
        },
        phone: {
          value: '',
          required: true,
          errors: [],
        },
        birthday: {
          value: '',
          format: /^(0[1-9]|1[0-2]) \/ (0[1-9]|1\d|2\d|3[01]) \/ (19|20)\d{2}$/,
          required: true,
          errors: [],
        },
        oldPassword: {
          value: '',
          required: true,
          errors: [],
        },
        newPassword: {
          value: '',
          required: true,
          errors: [],
        },
        confirmNewPassword: {
          value: '',
          required: true,
          errors: [],
        },
        email: {
          value: '',
          required: true,
          errors: [],
        },
        gender: {
          value: '',
          required: true,
          errors: [],
        },
        address: {
          value: {
            street: '',
            city: '',
            state: '',
            zip: '',
            country: '',
            apt: '',
            coords: {},
          },
          required: false,
          errors: [],
        },
        password: {
          value: '',
          required: false,
          errors: [],
        },
      },
      edit: {
        firstName: false,
        lastName: false,
        address: false,
        phone: false,
        password: false,
        birthday: false,
        gender: false,
      },
      initials: {
        firstName: '',
        lastName: '',
        address: '',
        phone: '',
        birthday: '',
        gender: '',
      },
      loaders: {
        firstName: false,
        lastName: false,
        address: false,
        phone: false,
        password: false,
        birthday: false,
        gender: false,
      },
      countryData: {},
      confirmError: false,
    };
  },
  created() {
    this.setValues();
  },
  methods: {
    setValues() {
      this.validations.firstName.value = this.user?.firstName;
      this.validations.lastName.value = this.user?.lastName;
      this.validations.birthday.value = this.user?.birthday;
      this.validations.phone.value = this.user?.phone;
      this.validations.email.value = this.user?.email;
      this.validations.gender.value = this.user?.gender;
      this.validations.address.value = { ...this.user?.address };
      if (!this.user?.address.country) {
        this.validations.address.value = this.user?.country;
      }
      this.allCountries = Country.getAllCountries().map((c) => {
        this.countryData[c.name] = c;
        return c.name;
      });
      this.setCountryStates();
    },
    setCountryStates() {
      this.allStates = State.getStatesOfCountry(
        this.countryData[this.validations.address.value.country]?.isoCode,
      ).map(city => city.name);
    },
    async onSave(item) {
      if (this.loaders[item]) {
        return;
      }
      this.loaders[item] = true;
      try {
        const { value } = this.validations[item];
        if (['firstName', 'lastName', 'phone', 'birthday'].includes(item)) {
          const validation = this.validate([item]);
          if (!validation.passed) {
            return;
          }
        }
        this.initials[item] = value;
        await this.$students({
          method: 'updateUser',
          payload: {
            updates: {
              [item]: value,
            },
          },
        });
        this.$store.dispatch('setGlobalValue', {
          item: this.user,
          key: item,
          value,
        });
        this.edit[item] = false;
        this.$notify({
          title: NOTIFICATION_SUCCESS,
          text: 'Perfil guardado',
          type: 'success',
        });
      } catch (e) {
        const message = e.message || e;
        this.$log.error(message);
        this.$notify({
          title: NOTIFICATION_ERROR,
          text: message,
          type: 'error',
          duration: -1,
        });
      } finally {
        this.loaders[item] = false;
      }
    },
    checkConfirm() {
      this.validations.newPassword.value = this.validations.newPassword.value.replace(/\s+/g, '');
      if (this.validations.confirmNewPassword.value.trim() !== '') {
        this.checkPass();
      }
    },
    checkPass() {
      const { confirmNewPassword, newPassword } = this.validations;
      if (newPassword.value === confirmNewPassword.value) {
        this.confirmError = false;
      } else {
        this.confirmError = this.formValidationMessages.passwordMatch;
      }
    },
    async onPasswordSave() {
      const validation = this.validate([
        'newPassword',
        'confirmNewPassword',
        'oldPassword',
      ]);
      if (!validation.passed) {
        return;
      }
      if (!this.criteriaPass) {
        return;
      }
      if (this.confirmError) {
        return;
      }
      this.loaders.password = true;
      try {
        const { oldPassword, newPassword } = this.validations;
        await this.$changePassword({
          newPass: newPassword.value,
          oldPass: oldPassword.value,
        });
        this.edit.password = false;
        this.$notify({
          title: NOTIFICATION_SUCCESS,
          text: 'Contraseña guardada',
          type: 'success',
        });
      } catch (e) {
        const message = e.message || e;
        this.$log.error(message);
        this.$notify({
          title: NOTIFICATION_ERROR,
          text: message,
          type: 'error',
          duration: -1,
        });
      } finally {
        this.loaders.password = false;
      }
    },
    toggleEdit(item) {
    // if editing but user hits cancel, reset to initial value & vice versa
      if (this.edit[item]) {
        this.validations[item].value = this.initials[item];
      } else {
        this.initials[item] = this.validations[item].value;
      }
      this.edit[item] = !this.edit[item];
    },
    setImageModal(val) {
      this.openImage = val;
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-input-grid {
    display: grid;
    grid-template-columns: 1fr max-content;
    grid-column-gap: 10px;
}

.lcu-address-buttons {
    display: flex;
    justify-content: flex-end;
}

.lcu-image-wrapper {
    height: 150px;
    width: 150px;
    position: relative;
    justify-self: flex-end;
    display: flex;
    position: relative;

    @media only screen and (max-width: $mobile-max) {
        justify-self: center;
    }
}

.lcu-profile-image {
    width: 100%;
    overflow: hidden;
    position: relative;
    border-radius: 50%;
    border: 1px solid $page-border;
}

.lcu-edit-imageBtn {
    border: 1px solid $page-border;
    background-color: $white;
    color: $legacy-primary;
    width: 30px;
    height: 30px;
    position: absolute;
    bottom: 8px;
    left: 8px;
    font-size: 18px;
    border-radius: 3px;

    &:hover {
        cursor: pointer;
    }

    &::after {
        display: inline-block;
        content: '\e808';
        font-family: 'lcu';
    }

    @media only screen and (max-width: $mobile-max) {
        left: auto;
        right: 8px;
    }
}

.lcu-profile-col1 {
    @media only screen and (max-width: $mobile-max) {
        grid-area: 2 / 1 / 3 / 3;
    }
}

.lcu-profile-col2 {
    @media only screen and (max-width: $mobile-max) {
        grid-area: 1 / 1 / 2 / 3;
    }
}

.lcu-icon-eyeSlash {
  background-color: transparent;
  border: 0;
  color: #b1b0b0;
  display: inline-block;
  font-size: 18px;
  position: absolute;
  right: 3px;
  text-align: center;
  top: 35px;

  &:hover {
    cursor: pointer;
  }

  &:before {
    content: '\e806';
    font-family: 'lcu';
  }
}

.lcu-icon-eye {

  &:before {
    content: '\e81c';
  }
}
</style>
